export default {
  instanceName: 'ClientPermissionAdd',

  gridIdentity: {
    formName: 'frm_sec_RL_add_edit',
    objectName: 'dbgrd_users',
  },

  columnDefs: [
    { headerName: 'Active', field: 'Active' },
    { headerName: 'LoginFull', field: 'LoginFull' },
    { headerName: 'GroupName', field: 'GroupName' },
  ],

  enableColumnsResize: true,
  enableRowSelection: true,
  selectFirstRow: true,

  columnConfigs: {
    Active: {
      iconComponent: (value) => (value === 1 ? 'ok' : 'cancel'),
    },
  },
}
